var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_54_101618)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 40,
    r: 40,
    fill: "#FF6600"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 44,
    cy: 40,
    r: 39.5,
    stroke: "#FF6600"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.3128 52.3998L44.0003 42.7123L53.6878 52.3998L56.4003 49.6873L46.7128 39.9998L56.4003 30.3123L53.6878 27.5998L44.0003 37.2873L34.3128 27.5998L31.6003 30.3123L41.2878 39.9998L31.6003 49.6873L34.3128 52.3998ZM44.0003 65.8332C40.4698 65.8332 37.133 65.1551 33.9899 63.7988C30.8469 62.4426 28.1021 60.5912 25.7555 58.2446C23.409 55.8981 21.5576 53.1533 20.2014 50.0103C18.8451 46.8672 18.167 43.5304 18.167 39.9998C18.167 36.4262 18.8451 33.0679 20.2014 29.9248C21.5576 26.7818 23.409 24.0478 25.7555 21.7228C28.1021 19.3978 30.8469 17.5571 33.9899 16.2009C37.133 14.8446 40.4698 14.1665 44.0003 14.1665C47.5739 14.1665 50.9323 14.8446 54.0753 16.2009C57.2184 17.5571 59.9524 19.3978 62.2774 21.7228C64.6024 24.0478 66.443 26.7818 67.7993 29.9248C69.1555 33.0679 69.8337 36.4262 69.8337 39.9998C69.8337 43.5304 69.1555 46.8672 67.7993 50.0103C66.443 53.1533 64.6024 55.8981 62.2774 58.2446C59.9524 60.5912 57.2184 62.4426 54.0753 63.7988C50.9323 65.1551 47.5739 65.8332 44.0003 65.8332ZM44.0003 61.9582C50.1142 61.9582 55.3024 59.8162 59.5649 55.5321C63.8274 51.2481 65.9587 46.0707 65.9587 39.9998C65.9587 33.886 63.8274 28.6978 59.5649 24.4353C55.3024 20.1728 50.1142 18.0415 44.0003 18.0415C37.9295 18.0415 32.7521 20.1728 28.468 24.4353C24.184 28.6978 22.042 33.886 22.042 39.9998C22.042 46.0707 24.184 51.2481 28.468 55.5321C32.7521 59.8162 37.9295 61.9582 44.0003 61.9582Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_54_101618",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.4 0 0 0 0 0 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_54_101618"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_54_101618",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.49440610c56e1e1052c5ef28691707b4.svg";
export { ForwardRef as ReactComponent };